import { render, staticRenderFns } from "./SaveTuitionCardTemplateModal.vue?vue&type=template&id=72f118b2&"
import script from "./SaveTuitionCardTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SaveTuitionCardTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports